

//working file
import React, { useState, useRef, useEffect } from "react";
import { Menu, MenuItem, Button } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";


interface HomeNavProps {
  isSystemData: { systemNumber: number; tagName: string; systemName: string }[];
  handleTabChange: (newValue: number) => void;
  isActiveTab: number;
}

const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: 0,
    minWidth: 180,
    color: "rgb(55, 65, 81)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const CustomizedMenus: React.FC<HomeNavProps> = ({
  isSystemData,
  handleTabChange,
  isActiveTab,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [selectedSystem, setSelectedSystem] = useState(
    isSystemData[isActiveTab].systemName
  );


  const savedSystemId = localStorage.getItem("selectedSystemId");
  useEffect(() => {
    if (savedSystemId) {
      const systagname = isSystemData.find(
        (item) => item.systemNumber === Number(savedSystemId)
      );
      if (systagname) {
        setSelectedSystem(systagname.systemName);
      }
    }
  }, [savedSystemId]);


  const [selectedIndex, setSelectedIndex] = useState<number>(isActiveTab);

  // Refs to track button and menu
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const menuPaperRef = useRef<HTMLDivElement | null>(null);

  const open = Boolean(anchorEl);

  // Function to check if the cursor is inside the button or menu
  const isCursorInside = (event: MouseEvent) => {
    if (!menuPaperRef.current || !buttonRef.current) return false;

    const menuBounds = menuPaperRef.current.getBoundingClientRect();
    const buttonBounds = buttonRef.current.getBoundingClientRect();

    return (
      (event.clientX >= menuBounds.left &&
        event.clientX <= menuBounds.right &&
        event.clientY >= menuBounds.top &&
        event.clientY <= menuBounds.bottom) ||
      (event.clientX >= buttonBounds.left &&
        event.clientX <= buttonBounds.right &&
        event.clientY >= buttonBounds.top &&
        event.clientY <= buttonBounds.bottom)
    );
  };

  // Mouse move event to detect when cursor leaves both menu and button
  const handleMouseMove = (event: MouseEvent) => {
    if (!isCursorInside(event)) {
      setAnchorEl(null);
      document.removeEventListener("mousemove", handleMouseMove);
    }
  };

  // Open menu on hover
  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  // Add event listener when menu opens
  useEffect(() => {
    if (open) {
      document.addEventListener("mousemove", handleMouseMove);
    } else {
      document.removeEventListener("mousemove", handleMouseMove);
    }

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, [open]);

  // Handle item selection
  const handleSelect = (systemName: string, index: number) => {
    // setSelectedSystem(system_tagname as string);
    setSelectedIndex(index);
    setSelectedSystem(systemName);
    handleTabChange(index);
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        ref={buttonRef}
        id="menu-button"
        variant="contained"
        disableElevation
        onMouseEnter={handleMouseEnter}
        endIcon={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      >
        {selectedSystem}
      </Button>
      <StyledMenu
        id="menu-list"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          ref: (node: any) => {
            if (node) {
              menuPaperRef.current = node;
            }
          },
        }}
        MenuListProps={{
          "aria-labelledby": "menu-button",
        }}
      >
        {isSystemData.map((item, index) => (
          <MenuItem
            key={item.systemNumber}
            onClick={() => handleSelect(item.systemName, index)}
            sx={{
              backgroundColor:
                selectedIndex === index ? "#f0f0f0" : "transparent",
              fontWeight: selectedIndex === index ? "bold" : "normal",
            }}
          >
            {item.systemName}
          </MenuItem>
        ))}
      </StyledMenu>
    </div>
  );
};

export default CustomizedMenus;
